<div class="user-avatar" [ngStyle]="{'width': (avatarWidth + (countryWidth / 2)) + 'rem', 'height': avatarHeight + 'rem'}">
  <div class="display-image">
    <div class="ig-loader" [ngStyle]="{'width': (avatarWidth + 1.75)+ 'rem', 'height': (avatarHeight + 1.75) + 'rem'}" >
      <img *ngIf="isLoadingNewStories" src="assets/images/ig_loading_active.gif" width="100%" height="100%" class="ig-inner-loaded" />
    </div>
    <img class='img-circle' src='{{userAvatarPicture}}' (load)="onLoadedImage()" (error)="resolveNoAvatarUrl()" [ngStyle]="{'width': avatarWidth + 'rem', 'height': avatarHeight + 'rem'}" [ngClass]="{'hide-image': this.isLoadingImage}"/>
  </div>
  <div *ngIf="showCountryFlagIcon && userCountryCode != null" class="display-country-flag"
        [ngStyle]="{'left': calculateLeftPosition() + 'rem', 'top': calculateTopPosition() + 'rem'}">
    <div class="flag-icon-background flag-icon-{{userCountryCode.toLowerCase()}} flag-icon-squared img-circle"
         [ngStyle]="{'width': countryWidth + 'rem', 'height': countryHeight + 'rem'}"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-user-avatar/achoo-user-avatar.component.html